@use 'src/styles/variables-bundle' as *;
@use 'src/templates/components/global/accessibility';

.ents-wishlist-button {
  position: relative;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  background: transparent;
  border: none;
  appearance: none;

  &:focus-within {
    @include outline;
  }

  &.styled {
    cursor: pointer;
    width: inherit;
    height: inherit;
    min-width: var(--ents-wishlist-button-min-size, spacer(10));
    min-height: var(--ents-wishlist-button-min-size, spacer(10));
    color: color('coal-100');
    display: inline-flex;
    align-items: center;
    justify-content: center;

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        color: color('breuninger-red');
      }

      &.no-color:hover {
        color: color('ash');
      }

      &.selected {
        &:hover:not(.pulse) {
          color: color('coal-100');
        }

        &.no-color {
          &:hover {
            color: color('ash');
          }
        }
      }
    }

    &.no-description:focus-within {
      outline-offset: -1px;
    }

    &.selected {
      color: color('breuninger-red');

      &.pulse svg {
        animation: pulse 0.7s ease-in-out;

        @include prefersReducedMotion {
          animation: none;
        }
      }

      &.no-color {
        color: color('coal-100');
      }
    }

    svg {
      width: var(--ents-wishlist-icon-size, auto);
      height: var(--ents-wishlist-icon-size, auto);
    }

    &:has(.ents-wishlist-button__text) {
      &.text {
        @include link-secondary;

        color: color('coal-100');

        svg {
          color: color('coal-100');
          margin-right: spacer(1);
        }

        &:hover:not(.selected) svg {
          color: color('breuninger-red');
        }

        &.selected {
          svg {
            color: color('breuninger-red');
          }
        }

        &.no-color:hover {
          color: color('ash');
        }
      }
    }
  }
}
